import { useEffect } from "react";

/**
 * Fuerza tema oscuro mientras el componente está montado.
 * Guarda el tema anterior y lo restaura al desmontar.
 * Útil para Landing, Login y otras pantallas públicas que solo
 * tienen diseño en tema oscuro.
 */
export function useForceDarkTheme() {
  useEffect(() => {
    const root = document.documentElement;
    const hadLight = root.classList.contains("light");
    if (hadLight) {
      root.classList.remove("light");
      root.classList.add("dark");
    }
    return () => {
      if (hadLight) {
        root.classList.remove("dark");
        root.classList.add("light");
      }
    };
  }, []);
}
